export default function timestampReducer(state = {}, { payload, type }) {
  switch (type) {
    case "SET_LAST_REQUEST":
      return { ...state, [payload.key]: payload.timestamp };
    default:
      return state;
  }
}

